export default __webpack_public_path__ + "static/media/clipboard-regular.834acd28.svg";